import React from 'react';
import { HeroVariant40 } from '../components/HeroVariant40';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage40() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1621">
      <Navigation data-id="element-1622" />
      <main data-id="element-1623">
        <HeroVariant40 data-id="element-1624" />
        <WhyUs data-id="element-1625" />
        <Services data-id="element-1626" />
        <FAQ data-id="element-1627" />
        <Testimonials data-id="element-1628" />
        <Consultation data-id="element-1629" />
      </main>
      <Footer data-id="element-1630" />
      <CookieBanner data-id="element-1631" />
      <FloatingContact data-id="element-1632" />
    </div>;
}